import { n as e } from "./context-BrD4AniQ.js";
import { n as t, t as n } from "./MarkerIcon-Bc3X9WQk.js";
import { useMemo as r } from "react";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/Map/Root/Markers/Cluster/styles.ts
var s = "\n  relative flex\n", c = "\n  -ml-6 -z-10 last:-z-20\n";
//#endregion
//#region src/components/Map/Root/Markers/Cluster/index.tsx
function l({ isActive: l = !1, colors: u, icon: d }) {
	let { zoom: f, mapProvider: p } = e(), m = r(() => p.name === "google" ? f - 1 < 11 : f < 10, [f, p]);
	return /* @__PURE__ */ o("div", {
		className: s,
		style: {
			"--background": u?.background,
			"--fill": u?.fill
		},
		children: [/* @__PURE__ */ a("div", {
			className: t,
			"data-is-zoomed-out": m,
			"data-is-active": l,
			children: /* @__PURE__ */ a(n, { icon: d })
		}), !m && /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a("div", { className: `${t} ${c}` }), /* @__PURE__ */ a("div", { className: `${t} ${c}` })] })]
	});
}
//#endregion
export { l as t };
